import { render, staticRenderFns } from "./indexHome.vue?vue&type=template&id=22a7bf74&scoped=true"
import script from "./indexHome.vue?vue&type=script&lang=js"
export * from "./indexHome.vue?vue&type=script&lang=js"
import style0 from "./indexHome.vue?vue&type=style&index=0&id=22a7bf74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7bf74",
  null
  
)

export default component.exports